import React from 'react';
import { Link as InertiaLink } from '@inertiajs/react';

const ConditionalLink = ({ href, children, className, style, ...props }) => {
  // Check if Inertia is active by verifying that window.Inertia exists
  const isInertiaActive = typeof window !== 'undefined' && window.Inertia;
  if (isInertiaActive) {
    return (
      <InertiaLink href={href} className={className} style={style} {...props}>
        {children}
      </InertiaLink>
    );
  }
  return (
    <a href={href} className={className} style={style} {...props}>
      {children}
    </a>
  );
};

export default ConditionalLink;
